import * as React from "react";
import { SetLabelStrategy } from "~/components/LabelStrategy/LabelStrategy";
interface AdvancedFiltersProps {
    children: React.ReactNode;
}
const labelStrategy = (fieldName: string) => `By ${fieldName}`;
export function AdvancedFilters({ children }: AdvancedFiltersProps) {
    return <SetLabelStrategy labelStrategy={labelStrategy}>{children}</SetLabelStrategy>;
}
